import { useEffect } from "react";

const SCRIPT_ID = "ezy-connect-v4";
const EZY_API = "https://api.ezy.ai";
const EZY_SITE = "oculera.health";
const EZY_VERSION = "4.2.0";
const EZY_TOKEN = "af992257d56c8ff3835d9835f8751c0cdee57bd8a7e72a5a10f2122ed8bbc9eb";
const EZY_SIG = "7t6Clb_wuyw2YdPK0Kz5jJLblb43g2j5o3uj_c52aVE";

export default function EzyConnectWidget() {
  useEffect(() => {
    if (process.env.REACT_APP_MODE === "OFFLINE" || document.getElementById(SCRIPT_ID)) {
      return;
    }

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.defer = true;
    script.src = `${EZY_API}/ezy-connect/v4/connect.min.js?site=${EZY_SITE}&v=${EZY_VERSION}&token=${EZY_TOKEN}&sig=${EZY_SIG}`;
    script.setAttribute("data-api", EZY_API);
    script.setAttribute("data-site", EZY_SITE);
    script.setAttribute("data-token", EZY_TOKEN);
    document.head.appendChild(script);
  }, []);

  return null;
}
